import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { MatTooltipModule } from '@angular/material/tooltip';
import { LoadingBoxComponent } from '../../../../../shared/components/loading-box/loading-box.component';
import { AbntPipe } from '../../../../../shared/pipes/abnt.pipe';
import { VendaDocumentoStruct } from '../../../../../shared/services/structs/vendas/venda-documento.struct';
import {
    PvColunaVm,
    PvMovimentoCard,
    PvPermissoesOportunidade,
    PvRaiaVm,
    resolverPermissoesOportunidade,
} from '../../processo-venda.models';
import { PvColunaComponent } from '../pv-coluna/pv-coluna.component';

/**
 * Uma raia do board: cabeçalho próprio e a fileira de colunas embaixo.
 *
 * É o nível que este board tem a mais que o de Compras — ali cada coluna fica solta no
 * quadro; aqui elas são agrupadas por processo ("colunas de colunas").
 */
@Component({
    selector: 'app-pv-raia',
    standalone: true,
    imports: [CommonModule, MatIconModule, MatTooltipModule, PvColunaComponent, LoadingBoxComponent, AbntPipe],
    templateUrl: './pv-raia.component.html',
    styleUrls: ['./pv-raia.component.css'],
})
export class PvRaiaComponent {
    @Input({ required: true }) raia: PvRaiaVm;
    @Input() isMostrarSoma = true;

    /** Renderiza a raia fantasma do carregamento. */
    @Input() isSkeleton = false;

    @Output() recolherRaia = new EventEmitter<PvRaiaVm>();
    @Output() recolherColuna = new EventEmitter<PvColunaVm>();
    @Output() verMais = new EventEmitter<PvColunaVm>();
    @Output() abrirCard = new EventEmitter<VendaDocumentoStruct>();
    @Output() moverCard = new EventEmitter<PvMovimentoCard>();
    @Output() criarModelo = new EventEmitter<VendaDocumentoStruct>();
    @Output() clonar = new EventEmitter<VendaDocumentoStruct>();
    @Output() verHistorico = new EventEmitter<VendaDocumentoStruct>();
    @Output() verOportunidadesCliente = new EventEmitter<VendaDocumentoStruct>();
    @Output() excluir = new EventEmitter<VendaDocumentoStruct>();
    @Output() verOportunidade = new EventEmitter<VendaDocumentoStruct>();
    @Output() criarOportunidade = new EventEmitter<VendaDocumentoStruct>();
    @Output() vincularOportunidade = new EventEmitter<VendaDocumentoStruct>();
    @Output() desvincularOportunidade = new EventEmitter<VendaDocumentoStruct>();
    @Output() lancarFinanceiro = new EventEmitter<VendaDocumentoStruct>();
    @Output() excluirFinanceiro = new EventEmitter<VendaDocumentoStruct>();
    @Output() lancarEstoque = new EventEmitter<VendaDocumentoStruct>();
    @Output() excluirEstoque = new EventEmitter<VendaDocumentoStruct>();
    /** Clique no indicador F: os lançamentos do financeiro, só para consultar. */
    @Output() verFinanceiro = new EventEmitter<VendaDocumentoStruct>();

    /** Repassados ao filho sem interpretação: quem decide é o shell. */
    @Input() aceitaCard: (card: VendaDocumentoStruct, destino: PvColunaVm) => boolean = () => false;
    @Input() podeArrastar = false;
    @Input() podeInserir = false;
    @Input() podeExcluir = false;
    /** Opcional só por causa da raia fantasma do carregamento, que não tem cards. */
    @Input() permissoesOportunidade: PvPermissoesOportunidade = resolverPermissoesOportunidade([]);
    @Input() podeLancarFinanceiro = false;
    @Input() podeExcluirFinanceiro = false;
    @Input() podeLancarEstoque = false;
    @Input() podeExcluirEstoque = false;
    @Input() cardEmArraste: VendaDocumentoStruct | null = null;

    @Output() arrasteIniciou = new EventEmitter<VendaDocumentoStruct>();
    @Output() arrasteTerminou = new EventEmitter<void>();
    @Output() ponteiroEntrou = new EventEmitter<PvColunaVm>();

    /** Contador da raia recolhida: soma dos cards das colunas dela. */
    public get totalDaRaia(): number {
        if (this.raia.totalCards != null) return this.raia.totalCards;

        return this.raia.colunas.reduce((acc, coluna) => acc + coluna.totalRegistros, 0);
    }
}
